jQuery(document).ready(() => {
  $(".blog-related-slick-js").slick({
    dots: false,
    arrow: true,
    infinite: false,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});



// WEBPACK FOOTER //
// ./scripts/modules/related-slider.js